import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
}

export default function FormatTextIcon(props: IconProps): JSX.Element {
  const { width, height } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || "34"}
      height={height || "28.607"}
      viewBox="0 0 34 28.607"
    >
      <rect
        id="Rectangle_1929"
        data-name="Rectangle 1929"
        width="34"
        height="28.607"
        rx="5"
        fill="#f9f9f9"
      />
      <path
        id="Aa"
        d="M8.75-2.119H3.291L2.285.665H.561L5.087-11.781H6.972L11.48.665H9.756ZM8.283-3.448,6.021-9.77,3.758-3.448Zm4.292-.844a5.528,5.528,0,0,1,.611-2.649A4.43,4.43,0,0,1,14.865-8.71a4.606,4.606,0,0,1,2.38-.629,4.367,4.367,0,0,1,2.245.557,3.71,3.71,0,0,1,1.419,1.4v-1.8h1.652V.665H20.909V-1.167A3.85,3.85,0,0,1,19.463.261a4.325,4.325,0,0,1-2.236.566A4.461,4.461,0,0,1,14.857.18a4.535,4.535,0,0,1-1.67-1.814A5.649,5.649,0,0,1,12.576-4.292Zm8.333.018a4,4,0,0,0-.449-1.94A3.17,3.17,0,0,0,19.248-7.48a3.3,3.3,0,0,0-1.679-.44,3.307,3.307,0,0,0-1.67.431,3.127,3.127,0,0,0-1.2,1.257,4,4,0,0,0-.449,1.94,4.094,4.094,0,0,0,.449,1.967A3.176,3.176,0,0,0,15.9-1.05a3.254,3.254,0,0,0,1.67.44,3.3,3.3,0,0,0,1.679-.44A3.157,3.157,0,0,0,20.46-2.325,4.054,4.054,0,0,0,20.909-4.274Z"
        transform="translate(5.439 19.781)"
        fill="#707070"
      />
    </svg>
  );
}
